import { j as f } from "./jsx-runtime-3tyXYecC.mjs";
import { F as P } from "./flex-Cc3osQLf.mjs";
import V, { useRef as S, useEffect as tt, useImperativeHandle as it, createRef as Ct, useMemo as At, useState as Tt } from "react";
import { g as Ot } from "./_commonjsHelpers-BkfeUUK-.mjs";
import { a as Rt, b as Lt } from "./theme-colors-uK40SfO5.mjs";
import { I as lt } from "./icon-v2-DGtVEk7e.mjs";
import { m as U } from "./tss-DN0acMKN.mjs";
import { D as Et } from "./divider-Dq5lrAFK.mjs";
import { S as jt } from "./Slider-CwXiUmiw.mjs";
import { T as Ht } from "./tooltip-Cy1xtUCm.mjs";
import { _ as It } from "./composeRefs-YONvD-rx.mjs";
const v = {
  100: {
    100: "#F5F5F5",
    300: "#696663",
    500: "#272625",
    900: "#000000"
  },
  75: {
    100: "#F5F5F5",
    300: "#94908F",
    500: "#545150",
    900: "#2C2B2A"
  },
  50: {
    100: "#F5F5F5",
    300: "#B4B2B1",
    500: "#767170",
    900: "#4E4C4B"
  }
}, N = {
  hue: 106,
  saturation: 75
}, k = 360, ct = 96, et = -10, nt = 25, rt = 45, B = {
  lowerBound: 60,
  upperBound: 174
}, ut = 5, z = [
  { label: window.jQuery ? $.__("Red") : "Red", start: 0, end: 29 },
  { label: window.jQuery ? $.__("Orange") : "Orange", start: 30, end: 59 },
  { label: window.jQuery ? $.__("Yellow") : "Yellow", start: 60, end: 89 },
  { label: window.jQuery ? $.__("Green") : "Green", start: 90, end: 149 },
  { label: window.jQuery ? $.__("Teal") : "Teal", start: 150, end: 179 },
  { label: window.jQuery ? $.__("Blue") : "Blue", start: 180, end: 239 },
  { label: window.jQuery ? $.__("Purple") : "Purple", start: 240, end: 299 },
  { label: window.jQuery ? $.__("Pink") : "Pink", start: 300, end: 329 },
  { label: window.jQuery ? $.__("Red") : "Red", start: 330, end: 359 },
  { label: window.jQuery ? $.__("Gray") : "Gray", start: k, end: k }
], Nt = 16, W = 360, ht = 3, R = W + ht + Nt, ft = [100, 75, 50, 25], Gt = 10;
function ot(t) {
  return t >= k;
}
function q(t) {
  return t >= B.lowerBound && t <= B.upperBound;
}
function Pt({ hue: t, saturation: e, lightness: n }) {
  if (ot(t) && e in v) {
    const r = v[e];
    return {
      backgroundBase: r[500],
      backgroundDark: r[900],
      backgroundLight: r[300]
    };
  }
  return {
    backgroundBase: `hsl(${t}, ${e}%, ${n}%)`,
    backgroundDark: `hsl(${t}, ${e}%, ${n + et}%)`,
    backgroundLight: `hsl(${t}, ${e}%, ${q(t) ? n + rt : n + nt}%)`
  };
}
const Bt = (t) => (z.find((n) => t >= n.start && t <= n.end) || z[z.length - 1]).label;
function Dt(t, e) {
  const n = Bt(t);
  switch (e) {
    case 25:
      return window.jQuery ? $.__("This is a shade of %s with the least saturation.", n) : `This is a shade of ${n} with the least saturation.`;
    case 50:
      return window.jQuery ? $.__("This is a shade of %s with a little saturation.", n) : `This is a shade of ${n} with a little saturation.`;
    case 75:
      return window.jQuery ? $.__("This is a shade of %s with medium saturation.", n) : `This is a shade of ${n} with medium saturation.`;
    case 100:
      return window.jQuery ? $.__("This is a shade of %s with a lot saturation.", n) : `This is a shade of ${n} with a lot of saturation.`;
    default:
      return "";
  }
}
function Y(t) {
  const e = t;
  return {
    100: v[e][100],
    300: v[e][300],
    500: v[e][500],
    900: v[e][900]
  };
}
const Kt = {
  0: 46,
  1: 46,
  2: 46,
  3: 46,
  4: 46,
  5: 46,
  6: 46,
  7: 45,
  8: 45,
  9: 45,
  10: 45,
  11: 44,
  12: 44,
  13: 44,
  14: 43,
  15: 43,
  16: 43,
  17: 42,
  18: 42,
  19: 41,
  20: 41,
  21: 40,
  22: 40,
  23: 40,
  24: 39,
  25: 39,
  26: 38,
  27: 38,
  28: 37,
  29: 37,
  30: 36,
  31: 36,
  32: 35,
  33: 35,
  34: 34,
  35: 34,
  36: 33,
  37: 33,
  38: 32,
  39: 32,
  40: 31,
  41: 31,
  42: 30,
  43: 30,
  44: 29,
  45: 29,
  46: 29,
  47: 28,
  48: 28,
  49: 27,
  50: 27,
  51: 27,
  52: 26,
  53: 26,
  54: 26,
  55: 25,
  56: 25,
  57: 25,
  58: 24,
  59: 24,
  60: 24,
  61: 24,
  62: 24,
  63: 24,
  64: 24,
  65: 24,
  66: 24,
  67: 24,
  68: 24,
  69: 24,
  70: 24,
  71: 25,
  72: 25,
  73: 25,
  74: 25,
  75: 25,
  76: 25,
  77: 25,
  78: 25,
  79: 25,
  80: 25,
  81: 25,
  82: 25,
  83: 25,
  84: 26,
  85: 26,
  86: 26,
  87: 26,
  88: 26,
  89: 26,
  90: 26,
  91: 26,
  92: 26,
  93: 26,
  94: 26,
  95: 26,
  96: 26,
  97: 26,
  98: 26,
  99: 26,
  100: 26,
  101: 26,
  102: 26,
  103: 26,
  104: 26,
  105: 26,
  106: 26,
  107: 26,
  108: 27,
  109: 27,
  110: 27,
  111: 27,
  112: 27,
  113: 27,
  114: 27,
  115: 27,
  116: 27,
  117: 27,
  118: 27,
  119: 27,
  120: 27,
  121: 27,
  122: 27,
  123: 27,
  124: 27,
  125: 27,
  126: 27,
  127: 27,
  128: 27,
  129: 27,
  130: 27,
  131: 27,
  132: 27,
  133: 27,
  134: 27,
  135: 27,
  136: 27,
  137: 27,
  138: 27,
  139: 27,
  140: 27,
  141: 27,
  142: 27,
  143: 27,
  144: 26,
  145: 26,
  146: 26,
  147: 26,
  148: 26,
  149: 26,
  150: 26,
  151: 26,
  152: 26,
  153: 26,
  154: 26,
  155: 26,
  156: 26,
  157: 26,
  158: 26,
  159: 26,
  160: 26,
  161: 26,
  162: 26,
  163: 26,
  164: 26,
  165: 26,
  166: 26,
  167: 26,
  168: 26,
  169: 26,
  170: 26,
  171: 26,
  172: 26,
  173: 26,
  174: 26,
  175: 26,
  176: 26,
  177: 26,
  178: 26,
  179: 26,
  180: 26,
  181: 26,
  182: 26,
  183: 27,
  184: 27,
  185: 28,
  186: 28,
  187: 29,
  188: 29,
  189: 30,
  190: 30,
  191: 31,
  192: 31,
  193: 32,
  194: 32,
  195: 33,
  196: 34,
  197: 34,
  198: 35,
  199: 36,
  200: 36,
  201: 37,
  202: 38,
  203: 39,
  204: 39,
  205: 40,
  206: 41,
  207: 42,
  208: 43,
  209: 44,
  210: 45,
  211: 46,
  212: 47,
  213: 48,
  214: 49,
  215: 50,
  216: 50,
  217: 50,
  218: 50,
  219: 50,
  220: 50,
  221: 50,
  222: 50,
  223: 50,
  224: 50,
  225: 50,
  226: 50,
  227: 50,
  228: 50,
  229: 50,
  230: 50,
  231: 50,
  232: 50,
  233: 50,
  234: 50,
  235: 50,
  236: 50,
  237: 50,
  238: 50,
  239: 50,
  240: 50,
  241: 50,
  242: 50,
  243: 50,
  244: 50,
  245: 50,
  246: 50,
  247: 50,
  248: 50,
  249: 50,
  250: 50,
  251: 50,
  252: 50,
  253: 50,
  254: 50,
  255: 50,
  256: 50,
  257: 50,
  258: 50,
  259: 50,
  260: 50,
  261: 50,
  262: 50,
  263: 50,
  264: 50,
  265: 50,
  266: 50,
  267: 50,
  268: 50,
  269: 50,
  270: 50,
  271: 50,
  272: 50,
  273: 50,
  274: 50,
  275: 50,
  276: 50,
  277: 50,
  278: 50,
  279: 50,
  280: 50,
  281: 50,
  282: 50,
  283: 50,
  284: 50,
  285: 50,
  286: 49,
  287: 48,
  288: 48,
  289: 47,
  290: 46,
  291: 46,
  292: 45,
  293: 45,
  294: 44,
  295: 43,
  296: 43,
  297: 42,
  298: 42,
  299: 41,
  300: 41,
  301: 41,
  302: 41,
  303: 41,
  304: 41,
  305: 42,
  306: 42,
  307: 42,
  308: 42,
  309: 42,
  310: 42,
  311: 42,
  312: 43,
  313: 43,
  314: 43,
  315: 43,
  316: 43,
  317: 43,
  318: 44,
  319: 44,
  320: 44,
  321: 44,
  322: 44,
  323: 44,
  324: 44,
  325: 44,
  326: 45,
  327: 45,
  328: 45,
  329: 45,
  330: 45,
  331: 45,
  332: 45,
  333: 45,
  334: 45,
  335: 45,
  336: 45,
  337: 46,
  338: 46,
  339: 46,
  340: 46,
  341: 46,
  342: 46,
  343: 46,
  344: 46,
  345: 46,
  346: 46,
  347: 46,
  348: 46,
  349: 46,
  350: 46,
  351: 46,
  352: 46,
  353: 46,
  354: 46,
  355: 46,
  356: 46,
  357: 46,
  358: 46,
  359: 46
};
function E(t) {
  return Kt[t];
}
const Ut = () => {
  const e = W / R * 100, n = e + ht / R * 100, r = n, o = 100, s = 9, a = W / (s - 1), i = Array.from({ length: s }, (u, h) => h * a / R * 100);
  return `linear-gradient(90deg, ${[
    `#E50000 ${i[0].toFixed(2)}%`,
    `#B25900 ${i[1].toFixed(2)}%`,
    `#7A7A00 ${i[2].toFixed(2)}%`,
    `#008516 ${i[3].toFixed(2)}%`,
    `#008073 ${i[4].toFixed(2)}%`,
    `#1100FF ${i[5].toFixed(2)}%`,
    `#8000FF ${i[6].toFixed(2)}%`,
    `#CC00B4 ${i[7].toFixed(2)}%`,
    `#E50000 ${i[8].toFixed(2)}%`,
    `#FFFFFF ${e.toFixed(2)}%`,
    `#FFFFFF ${n.toFixed(2)}%`,
    `#000000 ${r.toFixed(2)}%`,
    `#000000 ${o.toFixed(2)}%`
  ].join(", ")})`;
};
var dt = { exports: {} }, gt = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, bt = { exports: {} }, qt = function(e) {
  return !e || typeof e == "string" ? !1 : e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && e.constructor.name !== "String");
}, zt = qt, Qt = Array.prototype.concat, Vt = Array.prototype.slice, at = bt.exports = function(e) {
  for (var n = [], r = 0, o = e.length; r < o; r++) {
    var s = e[r];
    zt(s) ? n = Qt.call(n, Vt.call(s)) : n.push(s);
  }
  return n;
};
at.wrap = function(t) {
  return function() {
    return t(at(arguments));
  };
};
var Wt = bt.exports, L = gt, H = Wt, pt = Object.hasOwnProperty, mt = /* @__PURE__ */ Object.create(null);
for (var Q in L)
  pt.call(L, Q) && (mt[L[Q]] = Q);
var y = dt.exports = {
  to: {},
  get: {}
};
y.get = function(t) {
  var e = t.substring(0, 3).toLowerCase(), n, r;
  switch (e) {
    case "hsl":
      n = y.get.hsl(t), r = "hsl";
      break;
    case "hwb":
      n = y.get.hwb(t), r = "hwb";
      break;
    default:
      n = y.get.rgb(t), r = "rgb";
      break;
  }
  return n ? { model: r, value: n } : null;
};
y.get.rgb = function(t) {
  if (!t)
    return null;
  var e = /^#([a-f0-9]{3,4})$/i, n = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, r = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, o = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, s = /^(\w+)$/, a = [0, 0, 0, 1], i, l, u;
  if (i = t.match(n)) {
    for (u = i[2], i = i[1], l = 0; l < 3; l++) {
      var h = l * 2;
      a[l] = parseInt(i.slice(h, h + 2), 16);
    }
    u && (a[3] = parseInt(u, 16) / 255);
  } else if (i = t.match(e)) {
    for (i = i[1], u = i[3], l = 0; l < 3; l++)
      a[l] = parseInt(i[l] + i[l], 16);
    u && (a[3] = parseInt(u + u, 16) / 255);
  } else if (i = t.match(r)) {
    for (l = 0; l < 3; l++)
      a[l] = parseInt(i[l + 1], 0);
    i[4] && (i[5] ? a[3] = parseFloat(i[4]) * 0.01 : a[3] = parseFloat(i[4]));
  } else if (i = t.match(o)) {
    for (l = 0; l < 3; l++)
      a[l] = Math.round(parseFloat(i[l + 1]) * 2.55);
    i[4] && (i[5] ? a[3] = parseFloat(i[4]) * 0.01 : a[3] = parseFloat(i[4]));
  } else return (i = t.match(s)) ? i[1] === "transparent" ? [0, 0, 0, 0] : pt.call(L, i[1]) ? (a = L[i[1]], a[3] = 1, a) : null : null;
  for (l = 0; l < 3; l++)
    a[l] = x(a[l], 0, 255);
  return a[3] = x(a[3], 0, 1), a;
};
y.get.hsl = function(t) {
  if (!t)
    return null;
  var e = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, n = t.match(e);
  if (n) {
    var r = parseFloat(n[4]), o = (parseFloat(n[1]) % 360 + 360) % 360, s = x(parseFloat(n[2]), 0, 100), a = x(parseFloat(n[3]), 0, 100), i = x(isNaN(r) ? 1 : r, 0, 1);
    return [o, s, a, i];
  }
  return null;
};
y.get.hwb = function(t) {
  if (!t)
    return null;
  var e = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, n = t.match(e);
  if (n) {
    var r = parseFloat(n[4]), o = (parseFloat(n[1]) % 360 + 360) % 360, s = x(parseFloat(n[2]), 0, 100), a = x(parseFloat(n[3]), 0, 100), i = x(isNaN(r) ? 1 : r, 0, 1);
    return [o, s, a, i];
  }
  return null;
};
y.to.hex = function() {
  var t = H(arguments);
  return "#" + G(t[0]) + G(t[1]) + G(t[2]) + (t[3] < 1 ? G(Math.round(t[3] * 255)) : "");
};
y.to.rgb = function() {
  var t = H(arguments);
  return t.length < 4 || t[3] === 1 ? "rgb(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ")" : "rgba(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ", " + t[3] + ")";
};
y.to.rgb.percent = function() {
  var t = H(arguments), e = Math.round(t[0] / 255 * 100), n = Math.round(t[1] / 255 * 100), r = Math.round(t[2] / 255 * 100);
  return t.length < 4 || t[3] === 1 ? "rgb(" + e + "%, " + n + "%, " + r + "%)" : "rgba(" + e + "%, " + n + "%, " + r + "%, " + t[3] + ")";
};
y.to.hsl = function() {
  var t = H(arguments);
  return t.length < 4 || t[3] === 1 ? "hsl(" + t[0] + ", " + t[1] + "%, " + t[2] + "%)" : "hsla(" + t[0] + ", " + t[1] + "%, " + t[2] + "%, " + t[3] + ")";
};
y.to.hwb = function() {
  var t = H(arguments), e = "";
  return t.length >= 4 && t[3] !== 1 && (e = ", " + t[3]), "hwb(" + t[0] + ", " + t[1] + "%, " + t[2] + "%" + e + ")";
};
y.to.keyword = function(t) {
  return mt[t.slice(0, 3)];
};
function x(t, e, n) {
  return Math.min(Math.max(e, t), n);
}
function G(t) {
  var e = Math.round(t).toString(16).toUpperCase();
  return e.length < 2 ? "0" + e : e;
}
var Yt = dt.exports;
const j = gt, yt = {};
for (const t of Object.keys(j))
  yt[j[t]] = t;
const c = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
var wt = c;
for (const t of Object.keys(c)) {
  if (!("channels" in c[t]))
    throw new Error("missing channels property: " + t);
  if (!("labels" in c[t]))
    throw new Error("missing channel labels property: " + t);
  if (c[t].labels.length !== c[t].channels)
    throw new Error("channel and label counts mismatch: " + t);
  const { channels: e, labels: n } = c[t];
  delete c[t].channels, delete c[t].labels, Object.defineProperty(c[t], "channels", { value: e }), Object.defineProperty(c[t], "labels", { value: n });
}
c.rgb.hsl = function(t) {
  const e = t[0] / 255, n = t[1] / 255, r = t[2] / 255, o = Math.min(e, n, r), s = Math.max(e, n, r), a = s - o;
  let i, l;
  s === o ? i = 0 : e === s ? i = (n - r) / a : n === s ? i = 2 + (r - e) / a : r === s && (i = 4 + (e - n) / a), i = Math.min(i * 60, 360), i < 0 && (i += 360);
  const u = (o + s) / 2;
  return s === o ? l = 0 : u <= 0.5 ? l = a / (s + o) : l = a / (2 - s - o), [i, l * 100, u * 100];
};
c.rgb.hsv = function(t) {
  let e, n, r, o, s;
  const a = t[0] / 255, i = t[1] / 255, l = t[2] / 255, u = Math.max(a, i, l), h = u - Math.min(a, i, l), d = function(F) {
    return (u - F) / 6 / h + 1 / 2;
  };
  return h === 0 ? (o = 0, s = 0) : (s = h / u, e = d(a), n = d(i), r = d(l), a === u ? o = r - n : i === u ? o = 1 / 3 + e - r : l === u && (o = 2 / 3 + n - e), o < 0 ? o += 1 : o > 1 && (o -= 1)), [
    o * 360,
    s * 100,
    u * 100
  ];
};
c.rgb.hwb = function(t) {
  const e = t[0], n = t[1];
  let r = t[2];
  const o = c.rgb.hsl(t)[0], s = 1 / 255 * Math.min(e, Math.min(n, r));
  return r = 1 - 1 / 255 * Math.max(e, Math.max(n, r)), [o, s * 100, r * 100];
};
c.rgb.cmyk = function(t) {
  const e = t[0] / 255, n = t[1] / 255, r = t[2] / 255, o = Math.min(1 - e, 1 - n, 1 - r), s = (1 - e - o) / (1 - o) || 0, a = (1 - n - o) / (1 - o) || 0, i = (1 - r - o) / (1 - o) || 0;
  return [s * 100, a * 100, i * 100, o * 100];
};
function Jt(t, e) {
  return (t[0] - e[0]) ** 2 + (t[1] - e[1]) ** 2 + (t[2] - e[2]) ** 2;
}
c.rgb.keyword = function(t) {
  const e = yt[t];
  if (e)
    return e;
  let n = 1 / 0, r;
  for (const o of Object.keys(j)) {
    const s = j[o], a = Jt(t, s);
    a < n && (n = a, r = o);
  }
  return r;
};
c.keyword.rgb = function(t) {
  return j[t];
};
c.rgb.xyz = function(t) {
  let e = t[0] / 255, n = t[1] / 255, r = t[2] / 255;
  e = e > 0.04045 ? ((e + 0.055) / 1.055) ** 2.4 : e / 12.92, n = n > 0.04045 ? ((n + 0.055) / 1.055) ** 2.4 : n / 12.92, r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
  const o = e * 0.4124 + n * 0.3576 + r * 0.1805, s = e * 0.2126 + n * 0.7152 + r * 0.0722, a = e * 0.0193 + n * 0.1192 + r * 0.9505;
  return [o * 100, s * 100, a * 100];
};
c.rgb.lab = function(t) {
  const e = c.rgb.xyz(t);
  let n = e[0], r = e[1], o = e[2];
  n /= 95.047, r /= 100, o /= 108.883, n = n > 8856e-6 ? n ** (1 / 3) : 7.787 * n + 16 / 116, r = r > 8856e-6 ? r ** (1 / 3) : 7.787 * r + 16 / 116, o = o > 8856e-6 ? o ** (1 / 3) : 7.787 * o + 16 / 116;
  const s = 116 * r - 16, a = 500 * (n - r), i = 200 * (r - o);
  return [s, a, i];
};
c.hsl.rgb = function(t) {
  const e = t[0] / 360, n = t[1] / 100, r = t[2] / 100;
  let o, s, a;
  if (n === 0)
    return a = r * 255, [a, a, a];
  r < 0.5 ? o = r * (1 + n) : o = r + n - r * n;
  const i = 2 * r - o, l = [0, 0, 0];
  for (let u = 0; u < 3; u++)
    s = e + 1 / 3 * -(u - 1), s < 0 && s++, s > 1 && s--, 6 * s < 1 ? a = i + (o - i) * 6 * s : 2 * s < 1 ? a = o : 3 * s < 2 ? a = i + (o - i) * (2 / 3 - s) * 6 : a = i, l[u] = a * 255;
  return l;
};
c.hsl.hsv = function(t) {
  const e = t[0];
  let n = t[1] / 100, r = t[2] / 100, o = n;
  const s = Math.max(r, 0.01);
  r *= 2, n *= r <= 1 ? r : 2 - r, o *= s <= 1 ? s : 2 - s;
  const a = (r + n) / 2, i = r === 0 ? 2 * o / (s + o) : 2 * n / (r + n);
  return [e, i * 100, a * 100];
};
c.hsv.rgb = function(t) {
  const e = t[0] / 60, n = t[1] / 100;
  let r = t[2] / 100;
  const o = Math.floor(e) % 6, s = e - Math.floor(e), a = 255 * r * (1 - n), i = 255 * r * (1 - n * s), l = 255 * r * (1 - n * (1 - s));
  switch (r *= 255, o) {
    case 0:
      return [r, l, a];
    case 1:
      return [i, r, a];
    case 2:
      return [a, r, l];
    case 3:
      return [a, i, r];
    case 4:
      return [l, a, r];
    case 5:
      return [r, a, i];
  }
};
c.hsv.hsl = function(t) {
  const e = t[0], n = t[1] / 100, r = t[2] / 100, o = Math.max(r, 0.01);
  let s, a;
  a = (2 - n) * r;
  const i = (2 - n) * o;
  return s = n * o, s /= i <= 1 ? i : 2 - i, s = s || 0, a /= 2, [e, s * 100, a * 100];
};
c.hwb.rgb = function(t) {
  const e = t[0] / 360;
  let n = t[1] / 100, r = t[2] / 100;
  const o = n + r;
  let s;
  o > 1 && (n /= o, r /= o);
  const a = Math.floor(6 * e), i = 1 - r;
  s = 6 * e - a, a & 1 && (s = 1 - s);
  const l = n + s * (i - n);
  let u, h, d;
  switch (a) {
    default:
    case 6:
    case 0:
      u = i, h = l, d = n;
      break;
    case 1:
      u = l, h = i, d = n;
      break;
    case 2:
      u = n, h = i, d = l;
      break;
    case 3:
      u = n, h = l, d = i;
      break;
    case 4:
      u = l, h = n, d = i;
      break;
    case 5:
      u = i, h = n, d = l;
      break;
  }
  return [u * 255, h * 255, d * 255];
};
c.cmyk.rgb = function(t) {
  const e = t[0] / 100, n = t[1] / 100, r = t[2] / 100, o = t[3] / 100, s = 1 - Math.min(1, e * (1 - o) + o), a = 1 - Math.min(1, n * (1 - o) + o), i = 1 - Math.min(1, r * (1 - o) + o);
  return [s * 255, a * 255, i * 255];
};
c.xyz.rgb = function(t) {
  const e = t[0] / 100, n = t[1] / 100, r = t[2] / 100;
  let o, s, a;
  return o = e * 3.2406 + n * -1.5372 + r * -0.4986, s = e * -0.9689 + n * 1.8758 + r * 0.0415, a = e * 0.0557 + n * -0.204 + r * 1.057, o = o > 31308e-7 ? 1.055 * o ** (1 / 2.4) - 0.055 : o * 12.92, s = s > 31308e-7 ? 1.055 * s ** (1 / 2.4) - 0.055 : s * 12.92, a = a > 31308e-7 ? 1.055 * a ** (1 / 2.4) - 0.055 : a * 12.92, o = Math.min(Math.max(0, o), 1), s = Math.min(Math.max(0, s), 1), a = Math.min(Math.max(0, a), 1), [o * 255, s * 255, a * 255];
};
c.xyz.lab = function(t) {
  let e = t[0], n = t[1], r = t[2];
  e /= 95.047, n /= 100, r /= 108.883, e = e > 8856e-6 ? e ** (1 / 3) : 7.787 * e + 16 / 116, n = n > 8856e-6 ? n ** (1 / 3) : 7.787 * n + 16 / 116, r = r > 8856e-6 ? r ** (1 / 3) : 7.787 * r + 16 / 116;
  const o = 116 * n - 16, s = 500 * (e - n), a = 200 * (n - r);
  return [o, s, a];
};
c.lab.xyz = function(t) {
  const e = t[0], n = t[1], r = t[2];
  let o, s, a;
  s = (e + 16) / 116, o = n / 500 + s, a = s - r / 200;
  const i = s ** 3, l = o ** 3, u = a ** 3;
  return s = i > 8856e-6 ? i : (s - 16 / 116) / 7.787, o = l > 8856e-6 ? l : (o - 16 / 116) / 7.787, a = u > 8856e-6 ? u : (a - 16 / 116) / 7.787, o *= 95.047, s *= 100, a *= 108.883, [o, s, a];
};
c.lab.lch = function(t) {
  const e = t[0], n = t[1], r = t[2];
  let o;
  o = Math.atan2(r, n) * 360 / 2 / Math.PI, o < 0 && (o += 360);
  const a = Math.sqrt(n * n + r * r);
  return [e, a, o];
};
c.lch.lab = function(t) {
  const e = t[0], n = t[1], o = t[2] / 360 * 2 * Math.PI, s = n * Math.cos(o), a = n * Math.sin(o);
  return [e, s, a];
};
c.rgb.ansi16 = function(t, e = null) {
  const [n, r, o] = t;
  let s = e === null ? c.rgb.hsv(t)[2] : e;
  if (s = Math.round(s / 50), s === 0)
    return 30;
  let a = 30 + (Math.round(o / 255) << 2 | Math.round(r / 255) << 1 | Math.round(n / 255));
  return s === 2 && (a += 60), a;
};
c.hsv.ansi16 = function(t) {
  return c.rgb.ansi16(c.hsv.rgb(t), t[2]);
};
c.rgb.ansi256 = function(t) {
  const e = t[0], n = t[1], r = t[2];
  return e === n && n === r ? e < 8 ? 16 : e > 248 ? 231 : Math.round((e - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(e / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(r / 255 * 5);
};
c.ansi16.rgb = function(t) {
  let e = t % 10;
  if (e === 0 || e === 7)
    return t > 50 && (e += 3.5), e = e / 10.5 * 255, [e, e, e];
  const n = (~~(t > 50) + 1) * 0.5, r = (e & 1) * n * 255, o = (e >> 1 & 1) * n * 255, s = (e >> 2 & 1) * n * 255;
  return [r, o, s];
};
c.ansi256.rgb = function(t) {
  if (t >= 232) {
    const s = (t - 232) * 10 + 8;
    return [s, s, s];
  }
  t -= 16;
  let e;
  const n = Math.floor(t / 36) / 5 * 255, r = Math.floor((e = t % 36) / 6) / 5 * 255, o = e % 6 / 5 * 255;
  return [n, r, o];
};
c.rgb.hex = function(t) {
  const n = (((Math.round(t[0]) & 255) << 16) + ((Math.round(t[1]) & 255) << 8) + (Math.round(t[2]) & 255)).toString(16).toUpperCase();
  return "000000".substring(n.length) + n;
};
c.hex.rgb = function(t) {
  const e = t.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!e)
    return [0, 0, 0];
  let n = e[0];
  e[0].length === 3 && (n = n.split("").map((i) => i + i).join(""));
  const r = parseInt(n, 16), o = r >> 16 & 255, s = r >> 8 & 255, a = r & 255;
  return [o, s, a];
};
c.rgb.hcg = function(t) {
  const e = t[0] / 255, n = t[1] / 255, r = t[2] / 255, o = Math.max(Math.max(e, n), r), s = Math.min(Math.min(e, n), r), a = o - s;
  let i, l;
  return a < 1 ? i = s / (1 - a) : i = 0, a <= 0 ? l = 0 : o === e ? l = (n - r) / a % 6 : o === n ? l = 2 + (r - e) / a : l = 4 + (e - n) / a, l /= 6, l %= 1, [l * 360, a * 100, i * 100];
};
c.hsl.hcg = function(t) {
  const e = t[1] / 100, n = t[2] / 100, r = n < 0.5 ? 2 * e * n : 2 * e * (1 - n);
  let o = 0;
  return r < 1 && (o = (n - 0.5 * r) / (1 - r)), [t[0], r * 100, o * 100];
};
c.hsv.hcg = function(t) {
  const e = t[1] / 100, n = t[2] / 100, r = e * n;
  let o = 0;
  return r < 1 && (o = (n - r) / (1 - r)), [t[0], r * 100, o * 100];
};
c.hcg.rgb = function(t) {
  const e = t[0] / 360, n = t[1] / 100, r = t[2] / 100;
  if (n === 0)
    return [r * 255, r * 255, r * 255];
  const o = [0, 0, 0], s = e % 1 * 6, a = s % 1, i = 1 - a;
  let l = 0;
  switch (Math.floor(s)) {
    case 0:
      o[0] = 1, o[1] = a, o[2] = 0;
      break;
    case 1:
      o[0] = i, o[1] = 1, o[2] = 0;
      break;
    case 2:
      o[0] = 0, o[1] = 1, o[2] = a;
      break;
    case 3:
      o[0] = 0, o[1] = i, o[2] = 1;
      break;
    case 4:
      o[0] = a, o[1] = 0, o[2] = 1;
      break;
    default:
      o[0] = 1, o[1] = 0, o[2] = i;
  }
  return l = (1 - n) * r, [
    (n * o[0] + l) * 255,
    (n * o[1] + l) * 255,
    (n * o[2] + l) * 255
  ];
};
c.hcg.hsv = function(t) {
  const e = t[1] / 100, n = t[2] / 100, r = e + n * (1 - e);
  let o = 0;
  return r > 0 && (o = e / r), [t[0], o * 100, r * 100];
};
c.hcg.hsl = function(t) {
  const e = t[1] / 100, r = t[2] / 100 * (1 - e) + 0.5 * e;
  let o = 0;
  return r > 0 && r < 0.5 ? o = e / (2 * r) : r >= 0.5 && r < 1 && (o = e / (2 * (1 - r))), [t[0], o * 100, r * 100];
};
c.hcg.hwb = function(t) {
  const e = t[1] / 100, n = t[2] / 100, r = e + n * (1 - e);
  return [t[0], (r - e) * 100, (1 - r) * 100];
};
c.hwb.hcg = function(t) {
  const e = t[1] / 100, r = 1 - t[2] / 100, o = r - e;
  let s = 0;
  return o < 1 && (s = (r - o) / (1 - o)), [t[0], o * 100, s * 100];
};
c.apple.rgb = function(t) {
  return [t[0] / 65535 * 255, t[1] / 65535 * 255, t[2] / 65535 * 255];
};
c.rgb.apple = function(t) {
  return [t[0] / 255 * 65535, t[1] / 255 * 65535, t[2] / 255 * 65535];
};
c.gray.rgb = function(t) {
  return [t[0] / 100 * 255, t[0] / 100 * 255, t[0] / 100 * 255];
};
c.gray.hsl = function(t) {
  return [0, 0, t[0]];
};
c.gray.hsv = c.gray.hsl;
c.gray.hwb = function(t) {
  return [0, 100, t[0]];
};
c.gray.cmyk = function(t) {
  return [0, 0, 0, t[0]];
};
c.gray.lab = function(t) {
  return [t[0], 0, 0];
};
c.gray.hex = function(t) {
  const e = Math.round(t[0] / 100 * 255) & 255, r = ((e << 16) + (e << 8) + e).toString(16).toUpperCase();
  return "000000".substring(r.length) + r;
};
c.rgb.gray = function(t) {
  return [(t[0] + t[1] + t[2]) / 3 / 255 * 100];
};
const D = wt;
function Xt() {
  const t = {}, e = Object.keys(D);
  for (let n = e.length, r = 0; r < n; r++)
    t[e[r]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  return t;
}
function Zt(t) {
  const e = Xt(), n = [t];
  for (e[t].distance = 0; n.length; ) {
    const r = n.pop(), o = Object.keys(D[r]);
    for (let s = o.length, a = 0; a < s; a++) {
      const i = o[a], l = e[i];
      l.distance === -1 && (l.distance = e[r].distance + 1, l.parent = r, n.unshift(i));
    }
  }
  return e;
}
function te(t, e) {
  return function(n) {
    return e(t(n));
  };
}
function ee(t, e) {
  const n = [e[t].parent, t];
  let r = D[e[t].parent][t], o = e[t].parent;
  for (; e[o].parent; )
    n.unshift(e[o].parent), r = te(D[e[o].parent][o], r), o = e[o].parent;
  return r.conversion = n, r;
}
var ne = function(t) {
  const e = Zt(t), n = {}, r = Object.keys(e);
  for (let o = r.length, s = 0; s < o; s++) {
    const a = r[s];
    e[a].parent !== null && (n[a] = ee(a, e));
  }
  return n;
};
const J = wt, re = ne, _ = {}, oe = Object.keys(J);
function se(t) {
  const e = function(...n) {
    const r = n[0];
    return r == null ? r : (r.length > 1 && (n = r), t(n));
  };
  return "conversion" in t && (e.conversion = t.conversion), e;
}
function ae(t) {
  const e = function(...n) {
    const r = n[0];
    if (r == null)
      return r;
    r.length > 1 && (n = r);
    const o = t(n);
    if (typeof o == "object")
      for (let s = o.length, a = 0; a < s; a++)
        o[a] = Math.round(o[a]);
    return o;
  };
  return "conversion" in t && (e.conversion = t.conversion), e;
}
oe.forEach((t) => {
  _[t] = {}, Object.defineProperty(_[t], "channels", { value: J[t].channels }), Object.defineProperty(_[t], "labels", { value: J[t].labels });
  const e = re(t);
  Object.keys(e).forEach((r) => {
    const o = e[r];
    _[t][r] = ae(o), _[t][r].raw = se(o);
  });
});
var ie = _;
const C = Yt, m = ie, vt = [
  // To be honest, I don't really feel like keyword belongs in color convert, but eh.
  "keyword",
  // Gray conflicts with some method names, and has its own method defined.
  "gray",
  // Shouldn't really be in color-convert either...
  "hex"
], X = {};
for (const t of Object.keys(m))
  X[[...m[t].labels].sort().join("")] = t;
const K = {};
function p(t, e) {
  if (!(this instanceof p))
    return new p(t, e);
  if (e && e in vt && (e = null), e && !(e in m))
    throw new Error("Unknown model: " + e);
  let n, r;
  if (t == null)
    this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;
  else if (t instanceof p)
    this.model = t.model, this.color = [...t.color], this.valpha = t.valpha;
  else if (typeof t == "string") {
    const o = C.get(t);
    if (o === null)
      throw new Error("Unable to parse color from string: " + t);
    this.model = o.model, r = m[this.model].channels, this.color = o.value.slice(0, r), this.valpha = typeof o.value[r] == "number" ? o.value[r] : 1;
  } else if (t.length > 0) {
    this.model = e || "rgb", r = m[this.model].channels;
    const o = Array.prototype.slice.call(t, 0, r);
    this.color = Z(o, r), this.valpha = typeof t[r] == "number" ? t[r] : 1;
  } else if (typeof t == "number")
    this.model = "rgb", this.color = [
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255
    ], this.valpha = 1;
  else {
    this.valpha = 1;
    const o = Object.keys(t);
    "alpha" in t && (o.splice(o.indexOf("alpha"), 1), this.valpha = typeof t.alpha == "number" ? t.alpha : 0);
    const s = o.sort().join("");
    if (!(s in X))
      throw new Error("Unable to parse color from object: " + JSON.stringify(t));
    this.model = X[s];
    const { labels: a } = m[this.model], i = [];
    for (n = 0; n < a.length; n++)
      i.push(t[a[n]]);
    this.color = Z(i);
  }
  if (K[this.model])
    for (r = m[this.model].channels, n = 0; n < r; n++) {
      const o = K[this.model][n];
      o && (this.color[n] = o(this.color[n]));
    }
  this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}
p.prototype = {
  toString() {
    return this.string();
  },
  toJSON() {
    return this[this.model]();
  },
  string(t) {
    let e = this.model in C.to ? this : this.rgb();
    e = e.round(typeof t == "number" ? t : 1);
    const n = e.valpha === 1 ? e.color : [...e.color, this.valpha];
    return C.to[e.model](n);
  },
  percentString(t) {
    const e = this.rgb().round(typeof t == "number" ? t : 1), n = e.valpha === 1 ? e.color : [...e.color, this.valpha];
    return C.to.rgb.percent(n);
  },
  array() {
    return this.valpha === 1 ? [...this.color] : [...this.color, this.valpha];
  },
  object() {
    const t = {}, { channels: e } = m[this.model], { labels: n } = m[this.model];
    for (let r = 0; r < e; r++)
      t[n[r]] = this.color[r];
    return this.valpha !== 1 && (t.alpha = this.valpha), t;
  },
  unitArray() {
    const t = this.rgb().color;
    return t[0] /= 255, t[1] /= 255, t[2] /= 255, this.valpha !== 1 && t.push(this.valpha), t;
  },
  unitObject() {
    const t = this.rgb().object();
    return t.r /= 255, t.g /= 255, t.b /= 255, this.valpha !== 1 && (t.alpha = this.valpha), t;
  },
  round(t) {
    return t = Math.max(t || 0, 0), new p([...this.color.map(ce(t)), this.valpha], this.model);
  },
  alpha(t) {
    return t !== void 0 ? new p([...this.color, Math.max(0, Math.min(1, t))], this.model) : this.valpha;
  },
  // Rgb
  red: g("rgb", 0, b(255)),
  green: g("rgb", 1, b(255)),
  blue: g("rgb", 2, b(255)),
  hue: g(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, (t) => (t % 360 + 360) % 360),
  saturationl: g("hsl", 1, b(100)),
  lightness: g("hsl", 2, b(100)),
  saturationv: g("hsv", 1, b(100)),
  value: g("hsv", 2, b(100)),
  chroma: g("hcg", 1, b(100)),
  gray: g("hcg", 2, b(100)),
  white: g("hwb", 1, b(100)),
  wblack: g("hwb", 2, b(100)),
  cyan: g("cmyk", 0, b(100)),
  magenta: g("cmyk", 1, b(100)),
  yellow: g("cmyk", 2, b(100)),
  black: g("cmyk", 3, b(100)),
  x: g("xyz", 0, b(95.047)),
  y: g("xyz", 1, b(100)),
  z: g("xyz", 2, b(108.833)),
  l: g("lab", 0, b(100)),
  a: g("lab", 1),
  b: g("lab", 2),
  keyword(t) {
    return t !== void 0 ? new p(t) : m[this.model].keyword(this.color);
  },
  hex(t) {
    return t !== void 0 ? new p(t) : C.to.hex(this.rgb().round().color);
  },
  hexa(t) {
    if (t !== void 0)
      return new p(t);
    const e = this.rgb().round().color;
    let n = Math.round(this.valpha * 255).toString(16).toUpperCase();
    return n.length === 1 && (n = "0" + n), C.to.hex(e) + n;
  },
  rgbNumber() {
    const t = this.rgb().color;
    return (t[0] & 255) << 16 | (t[1] & 255) << 8 | t[2] & 255;
  },
  luminosity() {
    const t = this.rgb().color, e = [];
    for (const [n, r] of t.entries()) {
      const o = r / 255;
      e[n] = o <= 0.04045 ? o / 12.92 : ((o + 0.055) / 1.055) ** 2.4;
    }
    return 0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2];
  },
  contrast(t) {
    const e = this.luminosity(), n = t.luminosity();
    return e > n ? (e + 0.05) / (n + 0.05) : (n + 0.05) / (e + 0.05);
  },
  level(t) {
    const e = this.contrast(t);
    return e >= 7 ? "AAA" : e >= 4.5 ? "AA" : "";
  },
  isDark() {
    const t = this.rgb().color;
    return (t[0] * 2126 + t[1] * 7152 + t[2] * 722) / 1e4 < 128;
  },
  isLight() {
    return !this.isDark();
  },
  negate() {
    const t = this.rgb();
    for (let e = 0; e < 3; e++)
      t.color[e] = 255 - t.color[e];
    return t;
  },
  lighten(t) {
    const e = this.hsl();
    return e.color[2] += e.color[2] * t, e;
  },
  darken(t) {
    const e = this.hsl();
    return e.color[2] -= e.color[2] * t, e;
  },
  saturate(t) {
    const e = this.hsl();
    return e.color[1] += e.color[1] * t, e;
  },
  desaturate(t) {
    const e = this.hsl();
    return e.color[1] -= e.color[1] * t, e;
  },
  whiten(t) {
    const e = this.hwb();
    return e.color[1] += e.color[1] * t, e;
  },
  blacken(t) {
    const e = this.hwb();
    return e.color[2] += e.color[2] * t, e;
  },
  grayscale() {
    const t = this.rgb().color, e = t[0] * 0.3 + t[1] * 0.59 + t[2] * 0.11;
    return p.rgb(e, e, e);
  },
  fade(t) {
    return this.alpha(this.valpha - this.valpha * t);
  },
  opaquer(t) {
    return this.alpha(this.valpha + this.valpha * t);
  },
  rotate(t) {
    const e = this.hsl();
    let n = e.color[0];
    return n = (n + t) % 360, n = n < 0 ? 360 + n : n, e.color[0] = n, e;
  },
  mix(t, e) {
    if (!t || !t.rgb)
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof t);
    const n = t.rgb(), r = this.rgb(), o = e === void 0 ? 0.5 : e, s = 2 * o - 1, a = n.alpha() - r.alpha(), i = ((s * a === -1 ? s : (s + a) / (1 + s * a)) + 1) / 2, l = 1 - i;
    return p.rgb(
      i * n.red() + l * r.red(),
      i * n.green() + l * r.green(),
      i * n.blue() + l * r.blue(),
      n.alpha() * o + r.alpha() * (1 - o)
    );
  }
};
for (const t of Object.keys(m)) {
  if (vt.includes(t))
    continue;
  const { channels: e } = m[t];
  p.prototype[t] = function(...n) {
    return this.model === t ? new p(this) : n.length > 0 ? new p(n, t) : new p([...ue(m[this.model][t].raw(this.color)), this.valpha], t);
  }, p[t] = function(...n) {
    let r = n[0];
    return typeof r == "number" && (r = Z(n, e)), new p(r, t);
  };
}
function le(t, e) {
  return Number(t.toFixed(e));
}
function ce(t) {
  return function(e) {
    return le(e, t);
  };
}
function g(t, e, n) {
  t = Array.isArray(t) ? t : [t];
  for (const r of t)
    (K[r] || (K[r] = []))[e] = n;
  return t = t[0], function(r) {
    let o;
    return r !== void 0 ? (n && (r = n(r)), o = this[t](), o.color[e] = r, o) : (o = this[t]().color[e], n && (o = n(o)), o);
  };
}
function b(t) {
  return function(e) {
    return Math.max(0, Math.min(t, e));
  };
}
function ue(t) {
  return Array.isArray(t) ? t : [t];
}
function Z(t, e) {
  for (let n = 0; n < e; n++)
    typeof t[n] != "number" && (t[n] = 0);
  return t;
}
var he = p;
const A = /* @__PURE__ */ Ot(he);
function xt(t, e, n) {
  const r = q(t) ? rt : nt;
  return {
    100: A({ h: t, s: e, l: ct }).hex(),
    300: A({ h: t, s: e, l: n + r }).hex(),
    500: A({ h: t, s: e, l: n }).hex(),
    900: A({ h: t, s: e, l: n + et }).hex()
  };
}
const kt = (t) => t >= k ? "black" : A({ h: t, s: 100, l: E(t) }).string();
function fe(t) {
  return t[500].saturation < ut;
}
function de(t) {
  for (const e in v) {
    let n = !0;
    const r = v[e];
    for (const o in r) {
      const s = Number(o);
      if (t[s] !== r[s]) {
        n = !1;
        break;
      }
    }
    if (n)
      return { isMatch: !0, saturationKey: Number(e) };
  }
  return { isMatch: !1, saturationKey: null };
}
function O(t) {
  const e = A(t);
  return {
    hue: Math.round(e.hue()),
    lightness: Math.round(e.lightness()),
    saturation: Math.round(e.saturationl())
  };
}
function St(t) {
  return {
    100: O(t[100]),
    300: O(t[300]),
    500: O(t[500]),
    900: O(t[900])
  };
}
function ge(t) {
  for (const e of Rt)
    if (e.base === t[500])
      return !0;
  for (const e of Lt)
    if (e.base === t[500])
      return !0;
  return !1;
}
function be(t) {
  return ft.includes(t);
}
function pe(t) {
  if (!ge(t))
    return !0;
  const e = St(t), n = q(e[500].hue) ? rt : nt;
  return (
    // Check if the Saturation of 500 is either SATURATION_VALUES
    be(e[500].saturation) && // Check if the 100 value has a lightness of LIGHTEST_COLOR_LIGHTNESS
    e[100].lightness === ct && // Check if the lightness of the 300 value is the correct offset lighter than the lightness of the 500 value
    e[300].lightness === e[500].lightness + n && // Check if the lightness of the 900 value is DARKEST_COLOR_LIGHTNESS_FROM_BASE darker than the lightness of the 500 value's lightness
    e[900].lightness === e[500].lightness + et
  );
}
function Ft(t) {
  return ft.reduce(
    (n, r) => Math.abs(r - t) < Math.abs(n - t) ? r : n
  );
}
function me(t) {
  if (!t)
    return {
      isLegacy: !1,
      hsl: {
        hue: N.hue,
        lightness: E(N.hue),
        saturation: N.saturation
      }
    };
  const e = de(t);
  if (e.isMatch)
    return {
      isLegacy: !1,
      hsl: {
        hue: k,
        // Gray shades do not use dynamic hues
        lightness: E(N.hue),
        saturation: e.saturationKey
      }
    };
  const n = St(t), { hue: r, lightness: o, saturation: s } = n[500];
  if (pe(t)) {
    const a = Ft(s);
    return { isLegacy: !1, hsl: { hue: r, lightness: o, saturation: a } };
  }
  return fe(n) ? { isLegacy: !0, hsl: { hue: k, lightness: o, saturation: s } } : { isLegacy: !0, hsl: { hue: r, lightness: o, saturation: s } };
}
function ye(t) {
  return !!(t.hue === k && t.saturation === 25 || t.saturation === 100 && q(t.hue));
}
function Ke(t) {
  const { hue: e, saturation: n, lightness: r } = O(t);
  if (r <= Gt)
    return Y(100);
  if (n <= ut) {
    let l;
    return r <= 25 ? l = 100 : r <= 45 ? l = 75 : l = 50, Y(l);
  }
  let a = Ft(n);
  a === 100 && e >= B.lowerBound && e <= B.upperBound && (a = 75);
  const i = E(e);
  return xt(e, a, i);
}
const we = Ut(), ve = U()(({ borderRadiuses: t, mixins: e, constructs: n }, { hue: r }) => ({
  root: {
    height: 20,
    width: R,
    padding: 0,
    "& .MuiSlider-rail": {
      background: we,
      borderRadius: t[200],
      height: 20,
      opacity: 1
    },
    "& .MuiSlider-thumb": {
      backgroundColor: kt(r),
      border: "2px solid #FFFFFF",
      height: 30,
      width: 30,
      "&:before": {
        boxShadow: "none"
      },
      "&:focus-within, &:hover, &.Mui-active": {
        boxShadow: `0 0 0 4px ${e.alpha(n.surface.neutral.strong, 0.2)}`
      }
    },
    "& .MuiSlider-track": {
      display: "none"
    }
  }
}));
function xe({ biId: t, defaultValue: e, id: n, onChange: r }) {
  const o = V.useRef(null), s = V.useRef(null), { classes: a } = ve({ hue: e });
  function i(u) {
    const h = s.current;
    h && (h.style.backgroundColor = kt(u));
  }
  function l(u, h) {
    const d = ot(h) ? k : h;
    i(d), r(d);
  }
  return /* @__PURE__ */ f.jsx(
    jt,
    {
      "aria-label": "Hue Slider",
      className: a.root,
      "data-bi-id": t,
      defaultValue: e,
      id: n,
      max: R,
      min: 0,
      onChange: l,
      ref: o,
      slotProps: {
        thumb: { ref: s }
      },
      step: 1
    },
    e
  );
}
const ke = U()(({ palette: t, borderRadiuses: e, mixins: n, constructs: r }, { checked: o, size: s }) => ({
  checked: {
    fill: t.common.white,
    left: s === "sm" ? "16px" : "34px",
    position: "absolute",
    top: s === "sm" ? "10px" : "24px"
  },
  colorVariations: {
    bottom: 0,
    display: "flex",
    height: s === "sm" ? "12px" : "21px",
    left: 0,
    position: "absolute",
    width: "100%"
  },
  darkColorVariation: {
    backgroundColor: "var(--swatch-background-dark)",
    borderBottomLeftRadius: e[400],
    flex: 1,
    height: "100%"
  },
  lightColorVariation: {
    backgroundColor: "var(--swatch-background-light)",
    borderBottomRightRadius: e[400],
    flex: 1,
    height: "100%"
  },
  root: {
    backgroundColor: "var(--swatch-background-base)",
    borderRadius: s === "sm" ? e[300] : e[400],
    boxShadow: s === "sm" ? `1px 1px 0 1px ${n.alpha(r.surface.neutral.xxStrong, 0.03)}` : `1px 1px 0 5px ${n.alpha(r.surface.neutral.xxStrong, 0.03)}`,
    flexShrink: 0,
    height: s === "sm" ? "48px" : "92px",
    position: "relative",
    width: s === "sm" ? "48px" : "92px",
    "&:hover": {
      cursor: "pointer",
      outlineColor: "var(--swatch-background-dark)",
      outlineStyle: "solid",
      outlineWidth: `${s === "sm" ? "2px" : "4px"}`
    },
    ...o && {
      outlineColor: "var(--swatch-background-dark)",
      outlineStyle: "solid",
      outlineWidth: `${s === "sm" ? "2px" : "4px"}`
    }
  }
}));
function Se(t, e) {
  const n = t.current;
  if (n) {
    const { backgroundLight: r, backgroundBase: o, backgroundDark: s } = Pt(e);
    n.style.setProperty("--swatch-background-light", r), n.style.setProperty("--swatch-background-base", o), n.style.setProperty("--swatch-background-dark", s);
  }
}
function Mt({ apiRef: t, hsl: e, checked: n = !1, size: r = "sm" }) {
  const o = S(null), { classes: s } = ke({ checked: n, size: r }), a = (i) => {
    Se(o, i);
  };
  return tt(() => {
    a(e);
  }, [JSON.stringify(e)]), it(
    t,
    () => ({
      setHueAndLightness: ({ hue: i, lightness: l }) => {
        const { saturation: u } = e;
        a({ hue: i, lightness: l, saturation: u });
      }
    }),
    []
  ), /* @__PURE__ */ f.jsxs("div", { className: s.root, ref: o, children: [
    n && /* @__PURE__ */ f.jsx("div", { className: s.checked, children: /* @__PURE__ */ f.jsx(lt, { name: "circle-check-solid", size: r === "sm" ? 16 : 24 }) }),
    /* @__PURE__ */ f.jsxs("div", { className: s.colorVariations, children: [
      /* @__PURE__ */ f.jsx("div", { className: s.darkColorVariation }),
      /* @__PURE__ */ f.jsx("div", { className: s.lightColorVariation })
    ] })
  ] });
}
const Fe = U()(({ borderRadiuses: t, mixins: e, constructs: n }, { size: r }) => ({
  label: {
    borderRadius: r === "sm" ? t[300] : t[400],
    position: "relative",
    "&:focus-within": {
      boxShadow: `0 0 0 4px ${e.alpha(n.border.neutral.strong, 0.2)}`
    }
  },
  visuallyHidden: {
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    overflow: "hidden",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  }
})), Me = U()(({ borderRadiuses: t, mixins: e, constructs: n }, { size: r }) => ({
  root: {
    backgroundColor: n.surface.neutral.weak,
    borderRadius: r === "sm" ? t[300] : t[400],
    boxShadow: r === "sm" ? `1px 1px 0 1px ${e.alpha(n.surface.neutral.xxStrong, 0.03)}` : `1px 1px 0 5px ${e.alpha(n.surface.neutral.xxStrong, 0.03)}`,
    height: r === "sm" ? "48px" : "92px",
    position: "relative",
    width: r === "sm" ? "48px" : "92px"
  }
}));
function _e({ size: t = "sm", containerRef: e }) {
  const { classes: n } = Me({ size: t }), r = V.useRef(null);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      Ht,
      {
        anchorRef: r,
        content: window.jQuery ? $.__("This color option doesn't work for contrast reasons.") : "This color option doesn't work for contrast reasons."
      }
    ),
    /* @__PURE__ */ f.jsx("div", { className: n.root, ref: It(e, r), children: /* @__PURE__ */ f.jsx(P, { alignItems: "center", height: "100%", justifyContent: "center", children: /* @__PURE__ */ f.jsx(lt, { color: "neutral-medium", name: "circle-info-regular", size: 20 }) }) })
  ] });
}
function $e(t, e, n) {
  t.current && (t.current.style.display = n ? "none" : "block"), e.current && (e.current.style.display = n ? "block" : "none");
}
function Ce({
  apiRef: t,
  biId: e,
  defaultValue: n,
  id: r,
  size: o = "sm",
  checked: s = !1,
  name: a,
  onChange: i
}) {
  const { classes: l } = Fe({ size: o }), u = S(null), h = S(n), d = S(null), F = S(null), I = S(null);
  function _t({ hue: w, saturation: T }) {
    const M = d.current;
    M && M.setAttribute("aria-label", Dt(w, T));
  }
  function st(w) {
    const { hue: T, lightness: M } = w;
    h.current = w, $e(d, I, ye(w)), _t(w), u.current && u.current.setHueAndLightness({ hue: T, lightness: M });
  }
  function $t() {
    i == null || i(h.current);
  }
  return it(
    t,
    () => ({
      setHueAndLightness: ({ hue: w, lightness: T }) => {
        const M = h.current.saturation || 100;
        st({ hue: w, lightness: T, saturation: M });
      }
    }),
    []
  ), tt(() => {
    st(n);
  }, [JSON.stringify(n)]), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs("label", { className: l.label, "data-bi-id": e, id: r, ref: d, children: [
      /* @__PURE__ */ f.jsx(
        "input",
        {
          checked: s,
          className: l.visuallyHidden,
          defaultValue: n.saturation,
          name: a,
          onChange: $t,
          ref: F,
          type: "radio"
        }
      ),
      /* @__PURE__ */ f.jsx(Mt, { apiRef: u, checked: s, hsl: n, size: o })
    ] }),
    /* @__PURE__ */ f.jsx(_e, { containerRef: I, size: o })
  ] });
}
const Ae = [100, 75, 50, 25];
function Te() {
  return S(
    Ae.map((e) => ({
      ref: Ct(),
      saturation: e
    }))
  ).current;
}
function Oe({ value: t }) {
  const { hsl: e, isLegacy: n } = At(() => me(t), [t]), r = Te(), [o, s] = Tt(n ? e.saturation : void 0), a = (i) => {
    const l = E(i);
    i !== e.hue && s(void 0), r.forEach(({ ref: u }) => {
      const h = u.current;
      h && h.setHueAndLightness({ hue: i, lightness: l });
    });
  };
  return tt(() => {
    a(e.hue), s(n ? void 0 : e.saturation);
  }, [JSON.stringify(e), n]), {
    changeHue: a,
    checkedSaturation: o,
    initialHSL: e,
    saturationSwatches: r
  };
}
function Ue({ biId: t, id: e, value: n, onChange: r }) {
  const { changeHue: o, checkedSaturation: s, initialHSL: a, saturationSwatches: i } = Oe({ value: n });
  function l(h) {
    o(h);
  }
  function u({ hue: h, lightness: d, saturation: F }) {
    const I = ot(h) ? Y(F) : xt(h, F, d);
    r(I);
  }
  return /* @__PURE__ */ f.jsx("div", { "data-bi-id": t, "data-fabric-component": "ThemePicker", id: e, children: /* @__PURE__ */ f.jsxs(P, { alignContent: "baseline", flexDirection: "row", gap: 4, children: [
    /* @__PURE__ */ f.jsx(Mt, { checked: !0, hsl: a, size: "lg" }),
    /* @__PURE__ */ f.jsx(Et, { orientation: "vertical" }),
    /* @__PURE__ */ f.jsxs(P, { flexDirection: "column", gap: "19px", children: [
      /* @__PURE__ */ f.jsx(xe, { defaultValue: a.hue, onChange: l }),
      /* @__PURE__ */ f.jsx(P, { alignItems: "center", gap: 2, children: i.map(({ saturation: h, ref: d }) => /* @__PURE__ */ f.jsx(
        Ce,
        {
          apiRef: d,
          checked: s === h,
          defaultValue: {
            hue: a.hue,
            lightness: a.lightness,
            saturation: h
          },
          name: "swatch-group",
          onChange: u
        },
        h
      )) })
    ] })
  ] }) });
}
export {
  xe as H,
  Mt as S,
  Ue as T,
  Ke as h
};
//# sourceMappingURL=theme-picker-DfvDqLTZ.mjs.map
